import React from 'react';
import { useState, useEffect } from 'react';
import ResizeService from './../../../../../service/resize';
import UiService from './../../../../../service/ui';
import { NavLink } from 'react-router-dom';
import theme from './../../../../theme';

const Offer = ({ offer }) => {
    const getWidgetMyArchivedOffersStyle = () => theme.getWidgetMyArchivedOffersStyle(theme);
    const [ widgetMyArchivedOffersStyle, setWidgetMyArchivedOffersStyle ] = useState( getWidgetMyArchivedOffersStyle() );
    /* istanbul ignore next */
    const resizeEffect = ResizeService.buildOnResize(() => {
        setWidgetMyArchivedOffersStyle( getWidgetMyArchivedOffersStyle() );
    });
    useEffect(resizeEffect);
    return (
        <NavLink 
            style={{ ...theme.getGeneralTextLinkStyle(theme) }} 
            to={`/archived/offer/${offer.id}`}
        >
            <div style={widgetMyArchivedOffersStyle}>
                {
                    offer.flagged ? `&#x2691;` : ''
                }
                <div>
                    { offer.title }
                </div>
                <p>
                    { UiService.timeSince(offer.createdOn) }
                </p>
            </div>
        </NavLink>
    );
};

const PopulatedView = ({ list }) => {
    const getUserWidgetFlexParentStyle = () => theme.getUserWidgetFlexParentStyle(theme);
    const [ userWidgetFlexParentStyle, setUserWidgetFlexParentStyle] = useState(getUserWidgetFlexParentStyle());
    /* istanbul ignore next */
    const resizeEffect = ResizeService.buildOnResize(() => {
        setUserWidgetFlexParentStyle(getUserWidgetFlexParentStyle());
    });
    useEffect(resizeEffect);
    return (
        <section style={userWidgetFlexParentStyle}>
            {
                list.map((offer, index) => <Offer key={index} offer={offer} />)
            }
            <div style={{
                clear: 'both'
            }}></div>
        </section>
    );
};

const EmptyView = ({ userWidgetHeaderTextStyle }) => 
    <section>
        <p style={userWidgetHeaderTextStyle}>
            You have no archived offers.  
        </p>
        
    </section>

const WidgetMyArchivedOffersViewPanel = ({ data }) => {
    const getUserWidgetHeaderTextStyle = () => theme.getUserWidgetHeaderTextStyle(theme);
    const [ userWidgetHeaderTextStyle, setUserWidgetHeaderTextStyle ] = useState(getUserWidgetHeaderTextStyle());
    /* istanbul ignore next */
    const resizeEffect = ResizeService.buildOnResize(() => {
        setUserWidgetHeaderTextStyle( getUserWidgetHeaderTextStyle());
    });
    useEffect(resizeEffect);
    return (
        <section>
            <div style={userWidgetHeaderTextStyle}>
                <div>
                    My Past Offers
                </div>
            </div>
            {
                data.list.length < 1 ? 
                    <EmptyView userWidgetHeaderTextStyle={userWidgetHeaderTextStyle} /> : 
                        <PopulatedView list={data.list} />
            }
        </section>
    );
};


export default WidgetMyArchivedOffersViewPanel;
